import React from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';

interface FooterProps {
  version: string;
}

const Footer: React.FC<FooterProps> = ({ version }) => {
  return (
    <AppBar position="static" color="primary">
      <Toolbar>
        <Typography variant="body2" align="center">
          &copy; {new Date().getFullYear()} Ground Water Protection Council, Inc.
        </Typography>
        <Typography variant="body2" align="center" sx={{ flexGrow: 1 }}>
          Version: {version}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default Footer;
